import { render, staticRenderFns } from "./MultiselectScroll.vue?vue&type=template&id=11bc15fd&"
import script from "./MultiselectScroll.vue?vue&type=script&lang=js&"
export * from "./MultiselectScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports